import React from 'react';
import { useTranslation } from 'react-i18next';
import type { KeywordGroup } from '@brand24-original/llm-types';
import CellOverflow from '../cell-overflow/CellOverflow';
import BrandIcon from '../../../../shared/components/brand-icon/BrandIcon';
import './KeywordAliasesCell.scss';

interface KeywordAliasesCellProps {
  group: KeywordGroup;
  /** Domena marki — źródło favicona; bez niej zostaje kolorowa literka. */
  domain?: string;
  /** Kolor marki z palety raportu — tło literki, gdy favicona nie ma. */
  color?: string;
  /** Otwiera okno marki na zakładce „Śledzone nazwy”. */
  onOpen: () => void;
}

/** Nazwy marki w komórce tabeli — same chipy; edycja jest w oknie marki (`BrandNamesEditor`). */
export const KeywordAliasesCell: React.FC<KeywordAliasesCellProps> = ({
  group,
  domain,
  color,
  onOpen,
}) => {
  const { t } = useTranslation();

  // `KeywordGroup.aliases` to POZOSTAŁE warianty — główna nazwa siedzi na samym `group`, a komórka
  // ma pokazywać komplet nazw marki, więc doklejamy ją na początek listy.
  const chips = [group, ...group.aliases].map((alias) => (
    <span
      className={`keyword-aliases__chip${
        alias.status === 'ACTIVE' ? '' : ' keyword-aliases__chip--off'
      }`}
      title={alias.keyword}
    >
      <BrandIcon name={alias.keyword} domain={domain} color={color} size="xs" />
      <span className="keyword-aliases__chip-name">{alias.keyword}</span>
    </span>
  ));

  return (
    <CellOverflow chips={chips} emptyLabel="—" openTitle={t('trackedNamesShowAll')} onOpen={onOpen} />
  );
};

export default KeywordAliasesCell;
